import { Facebook, Instagram, Twitter, YouTube } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Avatar, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLoadChurchInfoQuery } from '../api/apiSlice';
import imgFacebook from '../assets/facebook.jpg';
import logo from '../assets/favicon.png';
import imgInstagram from '../assets/instagram.jpg';
import imgYoutube from '../assets/livestream.jpeg';
import imgTwitter from '../assets/twitter.jpg';
import imgWebsite from '../assets/website.jpg';
import Screen from '../components/fragments/Screen';
import '../styles/grid.css';

const spacing = 1.25;

export default function DiscoverTab() {
    const classes = useStyles();
    const state = useSelector((st) => st);

    const { churches } = state.list2;
    const { user } = state.auth;
    const { id: churchId } = user.church;

    const { data, isFetching } = useLoadChurchInfoQuery(churchId, {
        refetchOnMountOrArgChange: true,
    });

    const { name, avatar, website, facebook, twitter, instagram, youtube } =
        data?.data || churches?.find((church) => church.id == churchId) || {};

    return (
        <Screen loading={isFetching} tab title="Discover">
            <Grid item xs={12}>
                <Typography className="fw-bold">
                    Get to know more about your church and feel connected by
                    following, liking and commenting on your church social media
                    platforms
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <div>
                    <div
                        className={classes.gridList}
                        onClick={() =>
                            facebook && window.open(facebook, '_blank')
                        }
                        style={{
                            width: '100%',
                            height: 120,
                            backgroundImage: `url(${imgFacebook})`,
                        }}
                    >
                        <Avatar
                            style={{ background: '#1771E6' }}
                            className="mb-2"
                        >
                            <Facebook />
                        </Avatar>
                        <Typography>Facebook Page</Typography>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ flexGrow: 1 }}>
                            <Box
                                className={classes.gridList}
                                onClick={() =>
                                    instagram &&
                                    window.open(instagram, '_blank')
                                }
                                sx={{
                                    height: 120,
                                    mt: spacing,
                                    mr: spacing / 2,
                                    backgroundImage: `url(${imgInstagram})`,
                                }}
                            >
                                <Avatar
                                    style={{ background: '#E44487' }}
                                    className="mb-2"
                                >
                                    <Instagram />
                                </Avatar>
                                <Typography>Instagram Page</Typography>
                            </Box>
                            <Box
                                className={classes.gridList}
                                onClick={() => {
                                    website && window.open(website, '_blank');
                                }}
                                sx={{
                                    height: 120 * 1.6 + 10,
                                    mt: spacing,
                                    me: spacing / 2,
                                    backgroundImage: `url(${imgWebsite})`,
                                    maxWidth: window.innerWidth * 0.5,
                                }}
                            >
                                <Avatar className="mb-2 bg-white">
                                    <img
                                        style={{ width: 20, height: 20 }}
                                        src={avatar || logo}
                                        alt="logo"
                                    />
                                </Avatar>
                                <Typography>{name} Website</Typography>
                            </Box>
                        </div>
                        <div style={{ flexGrow: 1 }}>
                            <Box
                                className={classes.gridList}
                                onClick={() => {
                                    twitter && window.open(twitter, '_blank');
                                }}
                                sx={{
                                    flexGrow: 1,
                                    height: 120 * 1.6 + 10,
                                    mt: spacing,
                                    ml: spacing / 2,
                                    backgroundImage: `url(${imgTwitter})`,
                                }}
                            >
                                <Avatar
                                    className="mb-2"
                                    style={{
                                        background: '#1C99E6',
                                    }}
                                >
                                    <Twitter />
                                </Avatar>
                                <Typography>Twitter Page</Typography>
                            </Box>
                            <Box
                                className={classes.gridList}
                                onClick={() =>
                                    youtube && window.open(youtube, '_blank')
                                }
                                sx={{
                                    flexGrow: 1,
                                    height: 120,
                                    marginTop: spacing,
                                    marginLeft: spacing / 2,
                                    backgroundImage: `url(${imgYoutube})`,
                                }}
                            >
                                <Avatar className="mb-2 bg-danger">
                                    <YouTube />
                                </Avatar>
                                <Typography>Youtube Channel</Typography>
                            </Box>
                        </div>
                    </div>
                </div>
            </Grid>
        </Screen>
    );
}

const useStyles = makeStyles((theme) => ({
    gridList: {
        backgroundColor: 'rgba(0,0,0,.7)',
        backgroundSize: 'cover',
        backgroundBlendMode: 'soft-light',
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        borderRadius: theme.shape.borderRadius,
        padding: 16,
        color: '#fff',
    },
    caption: { padding: 20 },
}));
